<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { useLocalizationStore } from '@/stores/localization';
import VueTurnstile from 'vue-turnstile';
import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { getTurnTile } from '@/api/auth';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

import formAlerts from '@/components/form-alerts/form-alerts.vue';

const { status } = storeToRefs(useUserStore());
const { recaptcha } = storeToRefs(useLocalizationStore());
const { login } = useUserStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();

const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

let formAlert = ref();
const isSubmitting = ref(false);
const siteKey = ref('0x4AAAAAAAZqJH--lkL6CG4V');
const activeValidation = ref(false);
const token: any = ref(undefined);
const theme = ref(import.meta.env.VITE_Themename);

const turnstileTheme = computed(() => {
    return theme.value === 'dusk' ? 'light' : 'dark';
});

const validate = computed(() => {
    return yup.object({
        email: yup.string().required().email(),
        password: yup.string().required()
    });
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [email, password] = useFieldModel(['email', 'password']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    if(recaptcha.value === 1 && !token.value){ return; }
    isSubmitting.value = true;
    emit('onSubmit', true);
    const error = await login(values.email, values.password, token.value);
    emit('onSubmit', false);
    const prevRoute = router.options.history.state.back;
    activeValidation.value = false;
    isSubmitting.value = false;
    if (error) {
        resetForm();
        await formAlert.value.addMsg({type: 'error', content: 'modals.alerts.errorSubmitLoginForm'});
    } else {
        resetForm();
        await formAlert.value.addMsg({type: 'success', content: 'modals.alerts.successSubmitLoginForm'});

        // Reset token after success login
        token.value = undefined;
        
        //change to credits by default on login
        useUserStore().changePaymentMethod('credits');

        if (props.page) {
            if (prevRoute?.includes('profile')) {
                router.push({ path: prevRoute.toString() })
            } else {
                router.push({ name: 'grid' });
            }
        } else {
            closeModal('login');
        }
    }
});

function doLostPassword() {
    // TODO: refactor to store
    if (props.page) {
        router.push({ name: 'lostpassword' });
    } else {
        toggleModal('lostpassword');
    }
}

function doRegister() {
    // TODO: refactor to store
    if (props.page) {
        router.push({ name: 'register' });
    } else {
        toggleModal('register');
    }
}
</script>

<template src="./modal-login.html"></template>
